function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#32CF3A",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M7.92 0C3.546 0 0 3.546 0 7.92c0 4.374 3.546 7.92 7.92 7.92 4.374 0 7.92-3.546 7.92-7.92C15.835 3.548 12.292.005 7.92 0zm4.073 6.675l-4.498 4.497c-.213.212-.5.332-.8.332-.301 0-.59-.12-.801-.332L3.847 9.128c-.442-.443-.44-1.16.002-1.602.443-.442 1.16-.44 1.602.003l1.245 1.244 3.693-3.696c.441-.443 1.158-.445 1.601-.003.443.441.445 1.158.003 1.601z",
  transform: "translate(-186 -259) translate(186 259)"
}))));

var SvgSuccessCircle = function SvgSuccessCircle(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccessCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success-circle.fc114fa7.svg";
export { ForwardRef as ReactComponent };